import { z } from 'zod';
import { isoDateSchema, personNameSchema, uuidSchema } from './common.js';
import { funnelStageSchema, messengerSchema } from './funnel.js';
export const updateCandidateSchema = z.object({
    lastName: personNameSchema.optional(),
    firstName: personNameSchema.optional(),
    messenger: messengerSchema.nullable().optional(),
    messengerNick: z.string().trim().max(80).nullable().optional(),
    internshipDate: isoDateSchema.nullable().optional(),
    comment: z.string().trim().max(1000).nullable().optional(),
});
/**
 * Смена этапа воронки.
 *
 * Для ухода обязательны этап и причина: без них выбывший кандидат исчезает
 * из отчёта «Ушедшие», ради которого этот экран и существует.
 */
export const changeStageSchema = z
    .object({
    toStage: funnelStageSchema,
    occurredOn: isoDateSchema.optional(),
    note: z.string().trim().max(500).optional(),
    leftStage: funnelStageSchema.optional(),
    leaveReasonId: uuidSchema.optional(),
    leaveComment: z.string().trim().max(1000).optional(),
})
    .refine((value) => value.toStage !== 'ushel' || Boolean(value.leftStage), {
    message: 'Укажите этап, с которого ушёл кандидат',
    path: ['leftStage'],
})
    .refine((value) => value.toStage !== 'ushel' || Boolean(value.leaveReasonId), {
    message: 'Укажите причину ухода',
    path: ['leaveReasonId'],
});
export const createCandidateSchema = z.object({
    lastName: personNameSchema,
    firstName: personNameSchema,
    email: z.string().trim().toLowerCase().pipe(z.email('Проверьте адрес почты')),
    messenger: messengerSchema.optional(),
    messengerNick: z.string().trim().max(80).optional(),
    status: funnelStageSchema.default('obuchenie'),
    internshipDate: isoDateSchema.optional(),
    comment: z.string().trim().max(1000).optional(),
});
//# sourceMappingURL=candidates.js.map